import React, { useEffect, useState } from 'react';
import '../../../CSS/Materiales.css'
import moment from 'moment/moment';
import { useNavigate } from 'react-router';
import {TEST, getPermission} from '../../../Conexiones/Conexion';
import jsPDF from 'jspdf';
import { calibriBold,calibriRegular } from "../../../Fonts/font";
import { Modal} from 'react-bootstrap';
import { PropagateLoader} from 'react-spinners';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { getApi } from '../../../Conexiones/Models';
import { errorMessage, warningToast} from '../../../Utils/AlertMessage';
import Loading from '../../../Utils/Loading';

function Bitacora() {
    const navigate = useNavigate();
    const [isLoading,setIsLoading]=useState(false);
    const numObra=parseInt(sessionStorage.getItem("obra"));
    const [nombreObra,setNombreObra] = useState ('');
    const [dueño,setDueño] = useState ('');
    const [direccion,setDireccion] = useState('');
    const [fecha,setFecha] = useState('');
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;

    var registros = []
    var inicio='';
    var fin='';

    //MODAL DESCARGANDO
    const [showDescargar, setShowDescargar] = useState(false);
        const handleCloseDescarg = () => {
        setShowDescargar(false);
    }
    const handleShowDescarg = () =>{
        setShowDescargar(true);
    }

    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras/');
    }

    const getFecha = () =>{
        const date= moment (new Date());
        return(date.tz('America/Mexico_City').format('YYYY-MM-DD'));
    }

    useEffect (()=>{
        const getObra = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,32);
            if(permiso){
                const endpoint = 'obras/'+numObra;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setNombreObra(res.data[0].nombreObra);
                        setDueño(res.data[0].clienteObra);
                        setDireccion(res.data[0].direccionObra);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getObra()
    },[navigate,numObra,idUsuario])

    const getBitacora = async () =>{
        if(fecha ===undefined || fecha ===''){
            warningToast('DEBE INGRESAR UNA FECHA');
        }else{
            handleShowDescarg();
            const endpoint = 'bitacora-semana/'+numObra+"/"+fecha;
            const res = await getApi(endpoint);
            if(res.status === 1){
                if(res.data.length !== undefined){
                    registros=res.data[0].lista;
                    inicio=res.data[0].inicio;
                    fin=res.data[0].fin;
                }else{
                    errorMessage(res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
            if(registros.length===0){
                warningToast('NO EXISTEN REGISTROS DE LA FECHA SELECCIONADA');
            }else{
                descargar(registros,inicio,fin);
            }
            handleCloseDescarg();
        }
    }

    const descargar = (lista,ini,fin) => {
        setFecha("");
        var date = moment( new Date());
        const fecha = date.tz('America/Mexico_City').format('DD/MM/YYYY')
        //const fecha2 = date.tz('America/Mexico_City').format('DDMMYY')
        //console.log(fecha)
        var doc = new jsPDF({format: 'letter',orientation:"portrait",compress: true});
        var company_logo = {
            w: 30,
            h: 20
        };
        //var paginas=(datos.length/4)
        doc.deletePage(1)
        //NUMERO DE PAGINAS
        
        for(var i = 0; i < lista.length ; i++){
            doc.addPage({format: 'letter',orientation:"portrait"});
            //IMAGEN
            var imgData ="https://www.app-system.rosmocoin.com/rosmo-img/rosmo-logo-v2.png"
            doc.addImage(imgData,'JPEG',10,25,company_logo.w,company_logo.h);
            //console.log(doc.internal.pageSize.getHeight())
            //var logo = new Image();
            //logo.src = watermark;
            //doc.addImage(logo, 'JPEG',32.945, 89.7,150,100);
            //TITULO
            doc.addFileToVFS("calibri-bold.ttf", calibriBold);
            doc.addFont('calibri-bold.ttf', 'calibri-bold', 'bold');
            doc.setFont("calibri-bold","bold");
            doc.setFontSize(18);
            doc.setTextColor("#002060")
            doc.text("BITÁCORA DE OBRA", doc.internal.pageSize.getWidth() / 2, 15, null, 'center');
            //LINEA #1
            doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
            doc.setLineWidth(2.5);    
            doc.line(10, 18, 205, 18); // vertical line    
            //console.log(doc.internal.pageSize.getWidth())
            //obra,ubicación,ciudad,estado (TIPO DE LETRA BOLD)
            doc.setFont("calibri-bold","bold");
            doc.setFontSize(10);
            doc.setTextColor("black")
            doc.text("OBRA:", 70, 28, null, 'right');
            doc.text("UBICACIÓN:", 70, 33, null, 'right');
            doc.text("CIUDAD:", 70, 38, null, 'right');
            doc.text("ESTADO:", 70, 43, null, 'right');
            doc.text("FECHA:", 150, 45, null, 'right');
            doc.text("SEMANA:", 150, 49, null, 'right');
            //TIPO DE LETRA REGULAR
            doc.addFileToVFS("calibri-regular.ttf", calibriRegular);
            doc.addFont('calibri-regular.ttf', 'calibri-regular', 'normal');
            doc.setFont("calibri-regular","normal");
            doc.setFontSize(10);
            doc.text(nombreObra.toUpperCase(), 75, 28, null, 'left');
            doc.text(direccion.toUpperCase(), 75, 33, null, 'left');
            doc.text("CHILPANCINGO", 75, 38, null, 'left');
            doc.text("GUERRERO", 75, 43, null, 'left');
            //FECHA DESCARGA
            doc.setFont("calibri-regular","normal");
            doc.text(fecha, 165, 45, null, 'center');
            //FECHA DEL REPORTE
            doc.setFont("calibri-regular","normal");
            doc.text(moment(ini).format("DD/MM/YYYY")+" - " + moment(fin).format("DD/MM/YYYY"), 175, 49, null, 'center');

            //LINEA #2
            doc.setDrawColor("#1A2E4F", 0, 0); // draw red lines    
            doc.setLineWidth(1.0);    
            doc.line(10, 53, 205, 53); // vertical line  ancho 195
            
            //AGREGAR IMAGENES
            for(var j = 0; j < lista[i].length; j++) {
                //console.log(lista[i][j].orientacion)
                switch (j) {
                    case 0:
                        //ANCHO DE LA HOJA : 215.89
                        if(lista[i][j].orientacion===6){
                            doc.addImage(TEST+lista[i][j].nombreImg,'JPEG',10,-40,84.7,95.8,undefined,"FAST",-90);
                            doc.text(lista[i][j].comentario, 57.5, 145,{align:"center",maxWidth:85.8});
                        }else{
                            doc.addImage(TEST+lista[i][j].nombreImg,'JPEG',10,55,95.8,84.7,undefined,"FAST");
                            doc.text(lista[i][j].comentario,57.5, 145,{align:"center",maxWidth:85.8});
                        }       
                        break;
                    case 1:
                        if(lista[i][j].orientacion===6){
                            doc.addImage(TEST+lista[i][j].nombreImg,'JPEG',109,-40,84.7,95.8,undefined,"FAST",-90);
                            doc.text(lista[i][j].comentario, 155.5, 145,{align:"center",maxWidth:85.8});
                        }else{
                            doc.addImage(TEST+lista[i][j].nombreImg,'JPEG',109,56,95.8,84.7,undefined,"FAST");
                            doc.text(lista[i][j].comentario, 155.5, 145,{align:"center",maxWidth:85.8});
                        }                                        
                    break;
                    case 2:
                        if(lista[i][j].orientacion===6){
                            doc.addImage(TEST+lista[i][j].nombreImg,'JPEG',10,60,84.7,95.8,undefined,"FAST",-90);
                            doc.text(lista[i][j].comentario, 57.5, 245,{align:"center",maxWidth:85.8});
                        }else{
                            doc.addImage(TEST+lista[i][j].nombreImg,'JPEG',10,156,95.8,84.7,undefined,"FAST");
                            doc.text(lista[i][j].comentario, 57.5, 245,{align:"center",maxWidth:85.8});
                        } 
                    break;
                    case 3:
                        if(lista[i][j].orientacion===6){
                            doc.addImage(TEST+lista[i][j].nombreImg,'JPEG',109,60,84.7,95.8,undefined,"FAST",-90);
                            doc.text(lista[i][j].comentario, 155.5, 245,{align:"center",maxWidth:85.8});
                        }else{
                            doc.addImage(TEST+lista[i][j].nombreImg,'JPEG',109,156,95.8,84.7,undefined,"FAST");
                            doc.text(lista[i][j].comentario, 155.5, 245,{align:"center",maxWidth:85.8});
                        }
                    break;
                    default:
                    console.log(`ERROR`);
                }
            }
        }
        doc.save('BITACORA_'+nombreObra+' '+moment(ini,'YYYY/MM/DD').format('DD-MM-YYYY')+'_'+moment(fin,'YYYY/MM/DD').format('DD-MM-YYYY')+'.pdf');
        //doc.save('Gasto_Semanal_'+fecha2+'.pdf');
    }

    return (
        <div className="materiales">
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">BITÁCORA</label>
                    </div>
                    <div className="row">
                        <div  >
                            <label className=' text-uppercase membretado'>{"NOMBRE DE LA OBRA : " + nombreObra }</label><br></br>
                            <label className='membretado'>{"DUEÑO : " + dueño}</label>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:"50px",justifyContent:'center'}}>
                        <div className="fecha"  >
                            <label>SELECCIONAR FECHA:</label>
                            <input type="date" style={{marginTop:"30px"}} value={fecha} max={getFecha()} onChange={(e)=>setFecha(e.target.value)} className="form-control" required   aria-describedby="basic-addon1"/>
                            <button style={{marginTop:"30px"}} type="button" className="btn btncolor" onClick={()=> getBitacora(fecha)} >PDF</button>
                        </div>
                    </div>
                    
                    {/*DESCARGANDO....*/}
                    <Modal  show={showDescargar}  onHide={handleCloseDescarg} centered >
                        <Modal.Body  style={{textAlign:'center', marginTop:'15px',marginBottom:"5%"}}>
                            <div>
                                <h3>DESCARGANDO</h3>
                            </div>
                            <div style={{textAlign:'center', marginTop:'15px'}}>
                                <PropagateLoader color="#1A2E4F"/>
                            </div>
                        </Modal.Body>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default Bitacora;